import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FareReviewQueueState } from './fare-review-queue.reducer';

export const fareReviewQueueState = createFeatureSelector<FareReviewQueueState>('fareReviewQueue');

export const getFareReviewItems = createSelector(fareReviewQueueState, (state: FareReviewQueueState) => state.fareReviewItems);

export const getFareReviewTriggerTypes = createSelector(
  fareReviewQueueState,
  (state: FareReviewQueueState) => state.fareReviewTriggerTypes
);

export const isLoading = createSelector(fareReviewQueueState, (state: FareReviewQueueState) => state.loading);

export const getPageSize = createSelector(fareReviewQueueState, (state: FareReviewQueueState) => state.pageSize);

export const getPageNumber = createSelector(fareReviewQueueState, (state: FareReviewQueueState) => state.pageNumber);

export const getSelectedFareReviewTriggerName = createSelector(
  fareReviewQueueState,
  (state: FareReviewQueueState) => state.selectedFareReviewTriggerName
);
